module.exports = __webpack_public_path__ + "static/media/dong-hot.755662c6.png";